// extracted by mini-css-extract-plugin
export default {"advertCardPhoto":"c-a_gO","advertCardPhoto__image":"c-a_gP"};